import NotificationsWidget from './NotificationsWidget';

export default NotificationsWidget;
